import { render, staticRenderFns } from "./ActivateCountry.vue?vue&type=template&id=05fb3782&"
import script from "./ActivateCountry.vue?vue&type=script&lang=js&"
export * from "./ActivateCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports